import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { InfoCard, type InfoCardProps } from '@/components/contracts/InfoCard'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'

/** One metric card; its title is also the React key, so it is plain text. */
export type MoneySummaryMetric = InfoCardProps & { title: string }

export type MoneySummaryProps = {
  title: ReactNode
  description?: ReactNode
  metrics: MoneySummaryMetric[]
  children?: ReactNode
}

export function MoneySummary({ title, description, metrics, children }: MoneySummaryProps) {
  return (
    <Card surface="brandSubtle" className="@container/summary">
      <CardHeader>
        <CardTitle size="sm">{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className="space-y-5">
        <div
          className={cn(
            'grid gap-3 @xl/summary:grid-cols-2',
            metrics.length === 3
              ? '@4xl/summary:grid-cols-3'
              : metrics.length > 3 && '@4xl/summary:grid-cols-4'
          )}
        >
          {metrics.map((metric) => (
            <InfoCard key={metric.title} {...metric} />
          ))}
        </div>
        {children}
      </CardContent>
    </Card>
  )
}
